/* src/app/admin/client/client-area/client-area.component.scss */
.route-component {
  margin-left: 0px;
  margin-right: 0px;
}
/*# sourceMappingURL=client-area.component-ITFFCGKC.css.map */
